import { DOMAIN_TYPE_CHAT_MESSAGE } from '../../../consts';
export var getMessage = function (state) {
    return function (messageId) {
        return state.domain[DOMAIN_TYPE_CHAT_MESSAGE]
            ? state.domain[DOMAIN_TYPE_CHAT_MESSAGE][messageId]
            : null;
    };
};
